import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../lib/api";
import "./DepartmentEmployees.css";

const DepartmentEmployees = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [employees, setEmployees] = useState([]);
  const [departmentName, setDepartmentName] = useState("");

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const res = await api.get(`/departments/${id}/employees/`);
        setEmployees(res.data.employees);
        setDepartmentName(res.data.departmentName);
      } catch (err) {
        console.error("従業員取得エラー:", err);
      }
    };
    fetchEmployees();
  }, [id]);

  //  1列：10 人　を分けている
  const columns = [];
  for (let i = 0; i < employees.length; i += 10) {
    columns.push(employees.slice(i, i + 10));
  }

  return (
    <div className="employee-list-container">
      <h2 className="employee-title">{departmentName} のメンバー一覧</h2>

      <div className="employee-grid">
        {columns.map((col, colIndex) => (
          <div key={colIndex} className="employee-column">
            {col.map((emp) => (
              <div key={emp.memberId} className="employee-card">
                <p>{emp.employeeName}</p>
                <p className="id">{emp.memberId}</p>
              </div>
            ))}
          </div>
        ))}
      </div>

      <button className="btn-back" onClick={() => navigate(-1)}>
        戻る
      </button>
    </div>
  );
};

export default DepartmentEmployees;